<template>
    <div class="o-crop">
        <template v-if="activeSubstance">
            <m-title :title="activeSubstance.name" />
            <div
                class="l-row"
                v-if="activeSubstance.description && descriptionWithoutTags"
            >
                <div class="l-row__column">
                    <p class="a-label">Informacje o produkcie</p>
                    <p class="a-text" v-html="activeSubstance.description"></p>
                </div>
            </div>
            <template
                v-if="
                    activeSubstance.protectors &&
                        activeSubstance.protectors.length > 0
                "
            >
                <m-tabs
                    v-if="activeSubstanceRelated"
                    :items="activeSubstanceRelated"
                    @input="tab = $event.value"
                    :selected="tab"
                    :center="true"
                />
                <m-list
                    router-single-name="protector"
                    :list="activeSubstance.protectors"
                >
                    <template slot="list" slot-scope="props">
                        <div class="m-list__itemPhoto">
                            <a-image
                                v-if="
                                    props.item.photos &&
                                        props.item.photos.length > 0 &&
                                        !!props.item.photos.find(
                                            item => item.is_main === true
                                        )
                                "
                                :src="
                                    props.item.photos.find(
                                        item => item.is_main === true
                                    ).full_uri
                                "
                                :alt="props.item.name"
                            />
                            <a-icon v-else icon="Protectors" />
                        </div>
                        <p
                            class="
                                m-list__itemTitle
                                m-list__itemTitle--margins
                                m-list__itemTitle--capitalize
                            "
                            :style="
                                authIsAdvisor && props.item.position_group
                                    ? { color: props.item.position_group.hex }
                                    : false
                            "
                        >
                            {{ props.item.name }}
                            <span
                                v-if="props.item.is_deleted"
                                class="m-list__itemTitleRed"
                            >
                                <br />archiwalny
                            </span>
                        </p>
                        <div class="m-list__itemIcons">
                            <a-icon
                                v-if="props.item.youtube_link"
                                class="m-list__icon"
                                icon="Video"
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="
                                    props.item.notes &&
                                    props.item.notes.length > 0
                                        ? 'Note'
                                        : 'NoteLight'
                                "
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="
                                    props.item.is_favorite
                                        ? 'Favorite'
                                        : 'FavoriteLight'
                                "
                            />
                        </div>
                    </template>
                </m-list>
            </template>
        </template>
        <a-spinner v-else />
    </div>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: this.metaTitle
        }
    },
    data() {
        return {
            tab: '',
            metaTitle: 'Aktywna substancja'
        }
    },
    computed: {
        activeSubstance() {
            return this.$store.getters.activeSubstance
        },
        activeSubstanceStatus() {
            return this.$store.getters.activeSubstanceStatus
        },
        activeSubstanceRelated() {
            if (this.activeSubstance.protectors.length > 0) {
                return [
                    {
                        value: 'protectors',
                        label: 'Powiązane środki'
                    }
                ]
            } else {
                return null
            }
        },
        descriptionWithoutTags() {
            return this.activeSubstance.description.replace(/(<([^>]+)>)/gi, '')
        },
        photos() {
            return this.activeSubstance.photos.map(item => item.full_uri)
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        fetchActiveSubstance() {
            if (!isNaN(this.$route.params.id)) {
                this.$store
                    .dispatch('fetchActiveSubstance', this.$route.params.id)
                    .then(() => {
                        this.metaTitle = this.activeSubstance.name
                        // init tabs
                        if (
                            this.activeSubstance.protectors &&
                            this.activeSubstance.protectors.length > 0
                        ) {
                            this.tab = 'protectors'
                        }
                    })
            } else {
                this.$router.push({ name: 'error404' })
            }
        }
    },
    created() {
        this.fetchActiveSubstance()
    }
}
</script>
